import axios from "axios"

const apiClient = () => {
  const baseURL = process.env.VUE_APP_ACCOUNT_SITE_URL
  const header = {
    "Content-Type": "application/json",
    accept: "application/json"
  }

  const api = axios.create({
    baseURL,
    "Cache-Control": "no-cache",
    headers: header
  })

  return api
}

export default {
  checkVoucher(voucher) {
    return apiClient().get(`/api/v1/referral?referrer_code=${voucher}`)
  }
}
